/**
 * The session signal the router's `requireAuth` guard reads.
 *
 * This is a **contract, not an implementation**: token storage, binding persistence, and the
 * boot-time silent refresh are `web/auth/`'s deliverable (EXECUTION-ORDER.md §5 — split from
 * this PRD's router/component/theme/i18n/SW/manifest bulk). `web/auth/`'s provider is
 * expected to wrap the app and supply this context; until it does, the default value below
 * fails closed (`'loading'`) rather than assuming a signed-in session.
 */
import { createContext, useContext } from 'react'

export type AuthStatus =
  | { readonly state: 'loading' }
  /**
   * The boot read of the credentials rejected and is being retried. **Undecided, like `loading`,
   * and never `signed-out`**: the session may be on the phone, so the guard must not route to the
   * OTP screen, and `App` renders Home rather than the splash forever.
   */
  | { readonly state: 'restoring' }
  | { readonly state: 'signed-out' }
  | { readonly state: 'signed-in'; readonly pendingName: boolean }

export const AuthStatusContext = createContext<AuthStatus>({ state: 'loading' })

export function useAuthStatus(): AuthStatus {
  return useContext(AuthStatusContext)
}
